<ch-breadcrumb [parts]="breadcrumb" (goTo)="breadcrumbGoTo($event)"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    Locations
    <a id='locationListingNew' [routerLink]="['/admin/locations/add']" [queryParams]="{ parentId: pageParams.parentId }" class="btn btn-default pull-right">New</a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th class="sortable">
              <span class="col-name"
                >Name
                <ch-sortable [column]="'NAME'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>
              <a href (click)="goToSubroute(item.id)">{{ item.name }}</a>
            </td>
            <td class="col-md-1">
              <a class="btn btn-primary" [routerLink]="['/admin/locations/edit']" [queryParams]="{ id: item.id }">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination
      *ngIf="!loading"
      [totalItems]="totalItems"
      [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/locations/location-listing/location-listing.component.html